/* solaris-model 0.1.0 (MIT) + PPOrrery, lifted verbatim from sections/planet-view.liquid.
   2026-10-26 position fix: PPOrrery no longer reads planet angles from solaris-model (it solved
   Kepler's equation in degrees). The bundle below is kept only so nothing that might still
   reference window.SolarSystem breaks; PPOrrery itself never calls it. Both guard against double definition. */
!function(e,t){"object"==typeof exports&&"undefined"!=typeof module?module.exports=t():"function"==typeof define&&define.amd?define(t):e.SolarSystem=t()}(this,function(){"use strict";var e,t,n=[].slice,s=e=function(t,s){var i,a,r,o,l,u,p,m,h,d,c,f,y,w;if(t.privateInstances=new WeakMap,t.publicInstances=new WeakMap,i=function(){return function(){var e,s;e=1<=arguments.length?n.call(arguments,0):[],s=function(e,t,n){n.prototype=e.prototype;var s=new n,i=e.apply(s,t);return Object(i)===i?i:s}(t,e,function(){}),t.publicInstances.set(s,this),t.privateInstances.set(this,s)}}(),null!=(null!=s?s.properties:void 0))for(a=function(e){return Object.defineProperty(i.prototype,e,{get:function(){return t.privateInstances.get(this)[e]},set:function(n){return t.privateInstances.get(this)[e]=n}})},l=0,m=(c=s.properties).length;l<m;l++)a(c[l]);if(null!=(null!=s?s.methods:void 0))for(r=function(e){return i.prototype[e]=function(){var s,i;return s=1<=arguments.length?n.call(arguments,0):[],(i=t.privateInstances.get(this))[e].apply(i,s)}},u=0,h=(f=s.methods).length;u<h;u++)r(f[u]);if(null!=(null!=s&&null!=(y=s.static)?y.methods:void 0))for(o=function(e){return i[e]=function(){var s;return s=1<=arguments.length?n.call(arguments,0):[],t[e].apply(t,s)}},p=0,d=(w=s.static.methods).length;p<d;p++)o(w[p]);return((null!=s?s.expose:void 0)||e.expose||("undefined"!=typeof process&&null!==process?process.env.PUBLICIZER_EXPOSE:void 0))&&(i.PrivateClass=t,Object.defineProperty(i.prototype,"privateInstance",{get:function(){return t.privateInstances.get(this)}})),i},i=Object.freeze({G:6.67408e-11,metersInAU:149597870700}),a={kmToMeters:function(e){return 1e3*e},metersToKM:function(e){return e/1e3},AUToMeters:function(e){return e*i.metersInAU},metersToAU:function(e){return e/i.metersInAU}},r={J2000:new Date(Date.UTC(2e3,0,1,12,0,0)),dayInSeconds:86400,averageYearInDays:365.24,parse:function(e){return new Date(e+"T12:00:00Z")},addMilliseconds:function(e,t){return e.getTime()+t},addDays:function(e,t){var n;return(n=new Date(e)).setDate(n.getDate()+t),n},daysBetween:function(e,t){return(e-t)/1e3/86400},centuriesBetween:function(e,t){return(e-t)/1e3/86400/365.24/100},secondsToDays:function(e){return e/86400}};t=2*Math.PI;var o,l,u={degreesToRadians:function(e){return e*(Math.PI/180)},radiansToDegrees:function(e){return e*(180/Math.PI)},normalizeRadians:function(e){return e%t}},p=("undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self&&self,function(e,t){return t={exports:{}},e(t,t.exports),t.exports}(function(e,t){!function(t){function n(e,t){var n=Math.abs(e),s=Math.abs(t);return 0===e?Math.log(s):0===t?Math.log(n):n<3e3&&s<3e3?.5*Math.log(e*e+t*t):Math.log(e/Math.cos(Math.atan2(t,e)))}function s(e,t,n,s,i){if(void 0!==i)return e.w=t,e.x=n,e.y=s,void(e.z=i);if("object"==typeof t&&void 0===s){if("w"in t||"x"in t||"y"in t||"z"in t)return e.w=t.w||0,e.x=t.x||0,e.y=t.y||0,void(e.z=t.z||0);if("re"in t&&"im"in t)return e.w=t.re,e.x=t.im,e.y=0,void(e.z=0);if(4===t.length)return e.w=t[0],e.x=t[1],e.y=t[2],void(e.z=t[3]);if(3===t.length)return e.w=0,e.x=t[0],e.y=t[1],void(e.z=t[2]);throw new Error("Invalid object")}if("string"!=typeof t||void 0!==s)void 0===t&&e!==r?(e.w=1,e.x=e.y=e.z=0):(e.w=t||0,n&&3===n.length?(e.x=n[0],e.y=n[1],e.z=n[2]):(e.x=n||0,e.y=s||0,e.z=i||0));else{var a=t.match(/\d+\.?\d*e[+-]?\d+|\d+\.?\d*|\.\d+|./g),o=1,l=0,u={i:"x",j:"y",k:"z"};if(null===a)throw new Error("Parse error");e.w=e.x=e.y=e.z=0;for(var p=0;p<a.length;p++){var m=a[p],h=a[p+1];if(" "===m||"\t"===m||"\n"===m);else if("+"===m)o++;else if("-"===m)l++;else{if(o+l===0)throw new Error("Parse error"+m);var d=u[m];if(void 0!==d)" "===h||isNaN(h)?m="1":(m=h,p++);else{if(isNaN(m))throw new Error("Parser error");void 0!==(d=u[h])&&p++}e[d||"w"]+=parseFloat((l%2?"-":"")+m),o=l=0}}if(o+l>0)throw new Error("Parser error")}}function i(e,t,n){var s="";return 0!==e&&(""!==n?s+=e<0?" - ":" + ":e<0&&(s+="-"),1===(e=Math.abs(e))&&""!==t||(s+=e),s+=t),s}function a(e,t,n,i){if(!(this instanceof a))return new a(e,t,n,i);s(this,e,t,n,i)}var r={w:1,x:0,y:0,z:0};a.prototype={w:1,x:0,y:0,z:0,add:function(e,t,n,i){return s(r,e,t,n,i),new a(this.w+r.w,this.x+r.x,this.y+r.y,this.z+r.z)},sub:function(e,t,n,i){return s(r,e,t,n,i),new a(this.w-r.w,this.x-r.x,this.y-r.y,this.z-r.z)},neg:function(){return new a(-this.w,-this.x,-this.y,-this.z)},norm:function(){var e=this.w,t=this.x,n=this.y,s=this.z;return Math.sqrt(e*e+t*t+n*n+s*s)},normSq:function(){var e=this.w,t=this.x,n=this.y,s=this.z;return e*e+t*t+n*n+s*s},normalize:function(){var e=this.w,t=this.x,n=this.y,s=this.z,i=Math.sqrt(e*e+t*t+n*n+s*s);return i<a.EPSILON?a.ZERO:(i=1/i,new a(e*i,t*i,n*i,s*i))},mul:function(e,t,n,i){s(r,e,t,n,i);var o=this.w,l=this.x,u=this.y,p=this.z,m=r.w,h=r.x,d=r.y,c=r.z;return new a(o*m-l*h-u*d-p*c,o*h+l*m+u*c-p*d,o*d+u*m+p*h-l*c,o*c+p*m+l*d-u*h)},scale:function(e){return new a(this.w*e,this.x*e,this.y*e,this.z*e)},dot:function(e,t,n,i){return s(r,e,t,n,i),this.w*r.w+this.x*r.x+this.y*r.y+this.z*r.z},inverse:function(){var e=this.w,t=this.x,n=this.y,s=this.z,i=e*e+t*t+n*n+s*s;return 0===i?a.ZERO:(i=1/i,new a(e*i,-t*i,-n*i,-s*i))},div:function(e,t,n,i){s(r,e,t,n,i);var o=this.w,l=this.x,u=this.y,p=this.z,m=r.w,h=r.x,d=r.y,c=r.z,f=m*m+h*h+d*d+c*c;return 0===f?a.ZERO:(f=1/f,new a((o*m+l*h+u*d+p*c)*f,(l*m-o*h-u*c+p*d)*f,(u*m-o*d-p*h+l*c)*f,(p*m-o*c-l*d+u*h)*f))},conjugate:function(){return new a(this.w,-this.x,-this.y,-this.z)},exp:function(){var e=this.w,t=this.x,n=this.y,s=this.z,i=Math.sqrt(t*t+n*n+s*s),r=Math.exp(e),o=r/i*Math.sin(i);return 0===i?new a(r,0,0,0):new a(r*Math.cos(i),t*o,n*o,s*o)},log:function(){var e=this.w,t=this.x,s=this.y,i=this.z;if(0===s&&0===i)return new a(n(e,t),Math.atan2(t,e),0,0);var r=t*t+s*s+i*i+e*e,o=Math.sqrt(t*t+s*s+i*i),l=Math.atan2(o,e)/o;return new a(.5*Math.log(r),t*l,s*l,i*l)},pow:function(e,t,i,o){if(s(r,e,t,i,o),0===r.y&&0===r.z){if(1===r.w&&0===r.x)return this;if(0===r.w&&0===r.x)return a.ONE;if(0===this.y&&0===this.z){var l=this.w,u=this.x;if(0===l&&0===u)return a.ZERO;var p=Math.atan2(u,l),m=n(l,u);if(0===r.x){if(0===u&&l>=0)return new a(Math.pow(l,r.w),0,0,0);if(0===l)switch(r.w%4){case 0:return new a(Math.pow(u,r.w),0,0,0);case 1:return new a(0,Math.pow(u,r.w),0,0);case 2:return new a(-Math.pow(u,r.w),0,0,0);case 3:return new a(0,-Math.pow(u,r.w),0,0)}}return l=Math.exp(r.w*m-r.x*p),u=r.x*m+r.w*p,new a(l*Math.cos(u),l*Math.sin(u),0,0)}}return this.log().mul(r).exp()},equals:function(e,t,n,i){s(r,e,t,n,i);var o=a.EPSILON;return Math.abs(r.w-this.w)<o&&Math.abs(r.x-this.x)<o&&Math.abs(r.y-this.y)<o&&Math.abs(r.z-this.z)<o},isFinite:function(){return isFinite(this.w)&&isFinite(this.x)&&isFinite(this.y)&&isFinite(this.z)},isNaN:function(){return isNaN(this.w)||isNaN(this.x)||isNaN(this.y)||isNaN(this.z)},toString:function(){var e=this.w,t=this.x,n=this.y,s=this.z,a="";return isNaN(e)||isNaN(t)||isNaN(n)||isNaN(s)?"NaN":(a=i(e,"",a),a+=i(t,"i",a),a+=i(n,"j",a),""===(a+=i(s,"k",a))?"0":a)},real:function(){return this.w},imag:function(){return[this.x,this.y,this.z]},toVector:function(){return[this.w,this.x,this.y,this.z]},toMatrix:function(e){var t=this.w,n=this.x,s=this.y,i=this.z,a=t*t+n*n+s*s+i*i,r=0===a?0:2/a,o=r*t*n,l=r*t*s,u=r*t*i,p=r*n*n,m=r*n*s,h=r*n*i,d=r*s*s,c=r*s*i,f=r*i*i;return e?[[1-(d+f),m-u,h+l],[m+u,1-(p+f),c-o],[h-l,c+o,1-(p+d)]]:[1-(d+f),m-u,h+l,m+u,1-(p+f),c-o,h-l,c+o,1-(p+d)]},toMatrix4:function(e){var t=this.w,n=this.x,s=this.y,i=this.z,a=t*t+n*n+s*s+i*i,r=0===a?0:2/a,o=r*t*n,l=r*t*s,u=r*t*i,p=r*n*n,m=r*n*s,h=r*n*i,d=r*s*s,c=r*s*i,f=r*i*i;return e?[[1-(d+f),m-u,h+l,0],[m+u,1-(p+f),c-o,0],[h-l,c+o,1-(p+d),0],[0,0,0,1]]:[1-(d+f),m-u,h+l,0,m+u,1-(p+f),c-o,0,h-l,c+o,1-(p+d),0,0,0,0,1]},clone:function(){return new a(this)},rotateVector:function(e){var t=this.w,n=this.x,s=this.y,i=this.z,a=e[0],r=e[1],o=e[2],l=-n*a-s*r-i*o,u=t*a+s*o-i*r,p=t*r+i*a-n*o,m=t*o+n*r-s*a;return[u*t-l*n-p*i+m*s,p*t-l*s-m*n+u*i,m*t-l*i-u*s+p*n]}},a.ZERO=new a(0,0,0,0),a.ONE=new a(1,0,0,0),a.I=new a(0,1,0,0),a.J=new a(0,0,1,0),a.K=new a(0,0,0,1),a.EPSILON=1e-16,a.fromAxisAngle=function(e,t){var n=.5*t,s=e[0],i=e[1],r=e[2],o=Math.sin(n),l=Math.cos(n),u=o/Math.sqrt(s*s+i*i+r*r);return new a(l,s*u,i*u,r*u)},a.fromBetweenVectors=function(e,t){var n=e[0],s=e[1],i=e[2],r=t[0],o=t[1],l=t[2],u=n*r+s*o+i*l,p=s*l-i*o,m=i*r-n*l,h=n*o-s*r;return new a(u+Math.sqrt(u*u+p*p+m*m+h*h),p,m,h).normalize()},a.fromEuler=function(e,t,n,s){var i=.5*t,r=.5*n,o=.5*e,l=Math.cos(i),u=Math.cos(r),p=Math.cos(o),m=Math.sin(i),h=Math.sin(r),d=Math.sin(o);return void 0===s||"ZXY"===s?new a(l*u*p-m*h*d,m*u*p-l*h*d,l*h*p+m*u*d,l*u*d+m*h*p):"XYZ"===s?new a(l*u*p-m*h*d,m*u*p+l*h*d,l*h*p-m*u*d,l*u*d+m*h*p):"YXZ"===s?new a(l*u*p+m*h*d,m*u*p+l*h*d,l*h*p-m*u*d,l*u*d-m*h*p):"ZYX"===s?new a(l*u*p+m*h*d,m*u*p-l*h*d,l*h*p+m*u*d,l*u*d-m*h*p):"YZX"===s?new a(l*u*p-m*h*d,m*u*p+l*h*d,l*h*p+m*u*d,l*u*d-m*h*p):"XZY"===s?new a(l*u*p+m*h*d,m*u*p-l*h*d,l*h*p-m*u*d,l*u*d+m*h*p):null},e.exports=a}()})),m=function(e,t){function n(){this.constructor=e}for(var s in t)h.call(t,s)&&(e[s]=t[s]);return n.prototype=t.prototype,e.prototype=new n,e.__super__=t.prototype,e},h={}.hasOwnProperty,d=l=function(e){function t(){return t.__super__.constructor.apply(this,arguments)}return m(t,e),t}(s(o=function(){function e(e,t,n){var s;this.key=e,this.central=n,s=this.adaptData(t),this.name=s.name,this.type=s.type,this.radius=s.radius,this.elements=s.elements,this.mass=s.mass,this.tilt=s.tilt,this.ring=s.ring,this.position=s.position,this.mu=i.G*this.mass,this.satellites=Object.create(null)}return e.prototype.adaptData=function(e){var t;return e.radius=a.kmToMeters(e.radius),null==e.mass&&(e.mass=1),e.ring&&(e.ring.innerRadius=a.kmToMeters(e.ring.innerRadius),e.ring.outerRadius=a.kmToMeters(e.ring.outerRadius)),e.elements&&("jpl-satellites-table"===(t=e.elements.format)||"heavens-above"===t?e.elements.base.a=a.kmToMeters(e.elements.base.a):(e.elements.base.a=a.AUToMeters(e.elements.base.a),e.elements.base.cy&&(e.elements.base.cy=a.AUToMeters(e.elements.base.cy)))),e},e.prototype.setTime=function(e){this.time=e,this.elements&&(this.position=this.getPositionAtTime(this.time))},e.prototype.getPositionAtTime=function(e){var t,n,s,i,a,r,o,l,m,h,d,c,f;return o=this.getElementsAtTime(e),s=o.a,i=o.e,a=o.i,o.L,o.lp,r=o.node,d=o.w,n=o.M,t=o.E,l=[a,r,d,n,t].map(function(e){return u.degreesToRadians(e)}).map(function(e){return u.normalizeRadians(e)}),a=l[0],r=l[1],d=l[2],n=l[3],t=l[4],c=s*(Math.cos(t)-i),f=s*Math.sin(t)*Math.sqrt(1-Math.pow(i,2)),h=(null!=(m=this.central)?m.tilt:void 0)?u.degreesToRadians(-this.central.tilt):0,p.fromEuler(r,h,0,"XYZ").mul(p.fromEuler(d,a,0,"XYZ")).rotateVector([c,f,0])},e.prototype.getElementsAtTime=function(e){var t,n,s,i,a,r,o,l,u,p,m,h;return m=function(){var t,n,s,i;for(i=[],t=0,n=(s=["a","e","i","L","lp","node"]).length;t<n;t++)r=s[t],i.push(this.getElementAtTime(r,e));return i}.call(this),i=m[0],a=m[1],o=m[2],n=m[3],l=m[4],u=m[5],h=l-u,s=this.getMeanAnomaly(n,l,e),t=this.getEccentricAnomaly(s,a),this.central&&(p=2*Math.PI*Math.sqrt(Math.pow(i,3)/this.central.mu)),{a:i,e:a,i:o,L:n,lp:l,node:u,w:h,M:s,E:t,period:p}},e.prototype.getOrbitPath=function(){var e,t,n,s,i;for(s=[],n=1e3*this.getElementsAtTime(this.time).period/360,e=t=0;t<359;e=++t)i=r.addMilliseconds(this.time,n*e),s.push(this.getPositionAtTime(i));return s.push(s[0].slice()),s},e.prototype.getElementAtTime=function(e,t){var n,s;return s=this.elements.base[e],(null!=(n=this.elements.cy)?n[e]:void 0)&&(s+=this.elements.cy[e]*r.centuriesBetween(t,r.J2000)),s},e.prototype.getMeanAnomaly=function(e,t,n){var s,i;return s=e-t,(null!=(i=this.elements.day)?i.M:void 0)&&(s+=this.elements.day.M*r.daysBetween(n,r.J2000)),s},e.prototype.getEccentricAnomaly=function(e,t){var n,s;for(n=e;;)if(s=(n-t*Math.sin(n)-e)/(1-t*Math.cos(n)),n-=s,Math.abs(s)<1e-6)break;return n},e}(),{properties:["key","name","type","radius","elements","mass","tilt","ring","position","central","mu","satellites"],methods:["setTime","getPositionAtTime","getElementsAtTime","getElementAtTime","getOrbitPath"]})),c={sun:{name:"The Sun",type:"star",radius:695500,mass:1.988544e30,position:[0,0,0],satellites:{mercury:{name:"Mercury",type:"planet",radius:2440,mass:3.302e23,tilt:2.11,elements:{format:"jpl-1800-2050",base:{a:.38709927,e:.20563593,i:7.00497902,L:252.2503235,lp:77.45779628,node:48.33076593},cy:{a:3.7e-7,e:1906e-8,i:-.00594749,L:149472.67411175,lp:.16047689,node:-.12534081}}},venus:{name:"Venus",type:"planet",radius:6051.8,mass:4.8685e24,tilt:177.3,elements:{format:"jpl-1800-2050",base:{a:.72333566,e:.00677672,i:3.39467605,L:181.9790995,lp:131.60246718,node:76.67984255},cy:{a:39e-7,e:-4107e-8,i:-7889e-7,L:58517.81538729,lp:.00268329,node:-.27769418}}},earth:{name:"Earth",type:"planet",radius:6371.01,mass:5.97219e24,tilt:23.45,elements:{format:"jpl-1800-2050",base:{a:1.00000261,e:.01671123,i:-1531e-8,L:100.46457166,lp:102.93768193,node:0},cy:{a:562e-8,e:-4392e-8,i:-.01294668,L:35999.37244981,lp:.32327364,node:0}},satellites:{moon:{name:"The Moon",type:"moon",radius:1737.4,mass:7.349e22,tilt:6.67,elements:{format:"jpl-satellites-table",base:{a:384400,e:.0554,i:5.16,L:578.5,lp:443.23,node:125.08},day:{M:13.176358}}},iss:{name:"ISS",type:"spacecraft",radius:.1085*.0728/2,elements:{format:"heavens-above",base:{a:6781.6596564,e:6514e-7,i:51.6424,L:645.0066,lp:480.9673,node:284.9119},day:{M:360*15.54381896}}}}},mars:{name:"Mars",type:"planet",radius:3389.9,mass:6.4185e23,tilt:25.19,elements:{format:"jpl-1800-2050",base:{a:1.52371034,e:.0933941,i:1.84969142,L:-4.55343205,lp:-23.94362959,node:49.55953891},cy:{a:1847e-8,e:7882e-8,i:-.00813131,L:19140.30268499,lp:.44441088,node:-.29257343}},satellites:{phobos:{name:"Phobos",type:"moon",radius:33.5/3,mass:108e14,elements:{format:"jpl-satellites-table",base:{a:9376,e:.0151,i:1.075,L:448.9,lp:357.841,node:207.784},day:{M:1128.8447569}}},deimos:{name:"Deimos",type:"moon",radius:46.8*5.1/3,mass:18e14,elements:{format:"jpl-satellites-table",base:{a:23458,e:2e-4,i:1.788,L:610.583,lp:285.254,node:24.525},day:{M:285.161879}}}}},ceres:{name:"Ceres",type:"dwarfPlanet",radius:476.2,mass:9393e17,tilt:4,elements:{format:"jpl-sbdb",base:{a:2.767880825324262,e:.07568276766977486,i:10.59240162556512,L:420.0192342788,lp:153.217647542,node:80.30985818155804},day:{M:.2140341110610894}}},jupiter:{name:"Jupiter",type:"planet",radius:69911,mass:1.89813e27,tilt:3.12,elements:{format:"jpl-1800-2050",base:{a:5.202887,e:.04838624,i:1.30439695,L:34.39644051,lp:14.72847983,node:100.47390909},cy:{a:-11607e-8,e:-13253e-8,i:-.00183714,L:3034.74612775,lp:.21252668,node:.20469106}},satellites:{io:{name:"Io",type:"moon",radius:1821.3,mass:8.933e22,elements:{format:"jpl-satellites-table",base:{a:421800,e:.0041,i:.036,L:470.127,lp:128.106,node:43.977},day:{M:203.4889583}}},europa:{name:"Europa",type:"moon",radius:1565,mass:4.797e22,elements:{format:"jpl-satellites-table",base:{a:671100,e:.0094,i:.466,L:479.092,lp:308.076,node:219.106},day:{M:101.3747242}}},ganymede:{name:"Ganymede",type:"moon",radius:2634,mass:1.482e23,elements:{format:"jpl-satellites-table",base:{a:1070400,e:.0013,i:.177,L:573.509,lp:255.969,node:63.552},day:{M:50.3176072}}},callisto:{name:"Callisto",type:"moon",radius:2403,mass:1.076e23,elements:{format:"jpl-satellites-table",base:{a:1882700,e:.0074,i:.192,L:532.899,lp:351.491,node:298.848},day:{M:21.5710728}}}}},saturn:{name:"Saturn",type:"planet",radius:60268,mass:5.68319e26,tilt:26.73,ring:{innerRadius:66900,outerRadius:137774},elements:{format:"jpl-1800-2050",base:{a:9.53667594,e:.05386179,i:2.48599187,L:49.95424423,lp:92.59887831,node:113.66242448},cy:{a:-.0012506,e:-50991e-8,i:.00193609,L:1222.49362201,lp:-.41897216,node:-.28867794}},satellites:{mimas:{name:"Mimas",type:"moon",radius:198.8,mass:375e17,elements:{format:"jpl-satellites-table",base:{a:185539,e:.0196,i:1.574,L:520.374,lp:505.526,node:173.027},day:{M:381.9944948}}},enceladus:{name:"Enceladus",type:"moon",radius:252.3,mass:10805e16,elements:{format:"jpl-satellites-table",base:{a:238042,e:0,i:.003,L:542.269,lp:342.583,node:342.507},day:{M:262.7318978}}},tethys:{name:"Tethys",type:"moon",radius:536.3,mass:6176e17,elements:{format:"jpl-satellites-table",base:{a:294672,e:1e-4,i:1.091,L:548.411,lp:305.044,node:259.842},day:{M:190.6979109}}},dione:{name:"Dione",type:"moon",radius:562.5,mass:1.09572e21,elements:{format:"jpl-satellites-table",base:{a:377415,e:.0022,i:.028,L:896.962,lp:574.73,node:290.415},day:{M:131.5349307}}},rhea:{name:"Rhea",type:"moon",radius:764.5,mass:2.309e21,elements:{format:"jpl-satellites-table",base:{a:527068,e:2e-4,i:.333,L:772.442,lp:592.661,node:351.042},day:{M:79.6900459}}},titan:{name:"Titan",type:"moon",radius:2575.5,mass:1.34553e23,elements:{format:"jpl-satellites-table",base:{a:1221865,e:.0288,i:.306,L:371.902,lp:208.592,node:28.06},day:{M:22.5769756}}},hyperion:{name:"Hyperion",type:"moon",radius:133,mass:108e17,elements:{format:"jpl-satellites-table",base:{a:1500933,e:.1230061,i:.615,L:653.367,lp:567.025,node:263.847},day:{M:16.9199503}}},iapetus:{name:"Iapetus",type:"moon",radius:734.5,mass:1.8059e21,elements:{format:"jpl-satellites-table",base:{a:3560854,e:.0293,i:8.298,L:554.5,lp:352.711,node:81.105},day:{M:4.5379416}}},phoebe:{name:"Phoebe",type:"moon",radius:106.6,mass:8289e15,elements:{format:"jpl-satellites-table",base:{a:12947918,e:.1634,i:175.243,L:636.624,lp:583.586,node:241.086},day:{M:.6569114}}}}},uranus:{name:"Uranus",type:"planet",radius:25362,mass:8.68103e25,tilt:97.86,elements:{format:"jpl-1800-2050",base:{a:19.18916464,e:.04725744,i:.77263783,L:313.23810451,lp:170.9542763,node:74.01692503},cy:{a:-.00196176,e:-4397e-8,i:-.00242939,L:428.48202785,lp:.40805281,node:.04240589}},satellites:{titania:{name:"Titania",type:"moon",radius:788.9,mass:3.527e21,elements:{format:"jpl-satellites-table",base:{a:436300,e:.0011,i:.079,L:408.785,lp:384.171,node:99.771},day:{M:41.3514246}}}}},neptune:{name:"Neptune",type:"planet",radius:24624,mass:1.0241e26,tilt:29.56,elements:{format:"jpl-1800-2050",base:{a:30.06992276,e:.00859048,i:1.77004347,L:-55.12002969,lp:44.96476227,node:131.78422574},cy:{a:26291e-8,e:5105e-8,i:35372e-8,L:218.45945325,lp:-.32241464,node:-.00508664}},satellites:{triton:{name:"Triton",type:"moon",radius:1352.6,mass:2.147e22,tilt:.01,elements:{format:"jpl-satellites-table",base:{a:354759,e:0,i:156.865,L:596.007,lp:243.75,node:177.608},day:{M:61.2572638}}}}},pluto:{name:"Pluto",type:"dwarfPlanet",radius:1195,mass:1.307e22,tilt:122.5,elements:{format:"jpl-1800-2050",base:{a:39.48211675,e:.2488273,i:17.14001206,L:238.92903833,lp:224.06891629,node:110.30393684},cy:{a:-31596e-8,e:517e-7,i:4818e-8,L:145.20780515,lp:-.04062942,node:-.01183482}}},eris:{name:"Eris",type:"dwarfPlanet",radius:1163,elements:{format:"jpl-sbdb",base:{a:67.64830340711272,e:.442178729942388,i:44.19798212835923,L:392.0654311366,lp:187.3023562449,node:35.88062556130805},day:{M:.001771408442534513}}},sedna:{name:"Sedna",type:"dwarfPlanet",radius:497.5,elements:{format:"jpl-sbdb",base:{a:493.1571900553549,e:.8458267179852279,i:11.92883369990435,L:814.12651433,lp:456.0846992128,node:144.4983343551347},day:{M:8999658288375152e-20}}}}}},f=function(e,t){function n(){this.constructor=e}for(var s in t)y.call(t,s)&&(e[s]=t[s]);return n.prototype=t.prototype,e.prototype=new n,e.__super__=t.prototype,e},y={}.hasOwnProperty;return function(e){function t(){return t.__super__.constructor.apply(this,arguments)}return f(t,e),t}(s(function(){function e(){this.bodies=Object.create(null),this.importBodies(c),this.setTime(new Date)}return e.prototype.importBodies=function(e,t){var n,s,i;for(s in e)i=e[s],n=new d(s,i,t),this.bodies[s]=n,t&&(t.satellites[s]=n),i.satellites&&this.importBodies(i.satellites,n)},e.prototype.setTime=function(e){var t,n;this.time="string"==typeof e?r.parse(e):e,n=this.bodies;for(t in n)n[t].setTime(this.time)},e}(),{properties:["bodies","time"],methods:["setTime"]}))});
/* ==========================================================================
   Planetry Prints — PPOrrery
   --------------------------------------------------------------------------
   Browser renderer for the Planetry Prints poster art. No build step, no
   npm install. Since the 2026-10-26 position fix the orbital positions come
   from the same ephemeris as design-generator/utils/ephemeris.js (JPL's
   approximate Keplerian elements, solved in radians) at 12:00 UTC, and each
   dot is placed on its ring where the true direction from the Sun crosses it,
   exactly as design-generator/utils/ring-placement.js does for the prints.

   Geometry is a straight port of the compiled poster CSS at 2400x3000.
   The 2400x3000 "stage" is laid out in raw poster pixels and then mapped
   into whatever box the host element happens to be, so the art keeps the
   print's proportions at any size or aspect ratio.

     PPOrrery.anglesFor(date)     -> { mercury: deg, ... pluto: deg }  (true
                                     heliocentric longitudes, 0 = top, CCW)
     PPOrrery.ringAngle(name, deg) -> how far to turn that ring so its dot
                                     lies on the true direction from the Sun
     PPOrrery.create(host, opts)  -> instance
     PPOrrery.formatDate(date)    -> "10 August 2021"  (the print's date style)

     instance.setDate(date) | prepareDateTransition(date).seek(progress)
           | setTheme(t) | setFit(f) | setZoom(z)
           | setRules(bool) | refit() | destroy()
   ========================================================================== */

(function (global) {
  'use strict';

  if (global.PPOrrery) return;

  /* ---- poster geometry, exactly as Sass emitted it ---------------------- */

  var STAGE = { w: 2400, h: 3000 };
  var INNER_SCALE = 0.93;
  /* .solar-syst-inner: left 47%, top calc(35% + 12rem), + its 3.2px border */
  var ORIGIN = { x: STAGE.w * 0.47 + 3.2, y: STAGE.h * 0.35 + 192 + 3.2 };

  var BODIES = [
    { name: 'mercury', orb: 234.5,  ml: -73.28125,        mt: -111.6666666667 },
    { name: 'venus',   orb: 360,    ml: -133.3333333333,  mt: -171.4285714286 },
    { name: 'earth',   orb: 507.5,  ml: -203,             mt: -236.0465116279 },
    { name: 'mars',    orb: 665,    ml: -277.0833333333,  mt: -306.4516129032 },
    { name: 'jupiter', orb: 1149.2, ml: -522.3636363636,  mt: -552.5 },
    { name: 'saturn',  orb: 1408,   ml: -640,             mt: -686.8292682927 },
    { name: 'uranus',  orb: 1674.4, ml: -761.0909090909,  mt: -816.7804878049 },
    { name: 'neptune', orb: 1984.5, ml: -923.023255814,   mt: -945 },
    { name: 'pluto',   orb: 2106,   ml: -983,             mt: -1130 }
  ];

  /* Bounding box of the drawn system, in stage pixels. Used by fit:"system"
     so a 9:16 reel frame can centre on the orbits instead of the paper. */
  var BBOX = (function () {
    var minX = Infinity, maxX = -Infinity, minY = Infinity, maxY = -Infinity;
    for (var i = 0; i < BODIES.length; i++) {
      var b = BODIES[i];
      if (b.ml < minX) minX = b.ml;
      if (b.ml + b.orb > maxX) maxX = b.ml + b.orb;
      if (b.mt < minY) minY = b.mt;
      if (b.mt + b.orb > maxY) maxY = b.mt + b.orb;
    }
    return {
      w: (maxX - minX) * INNER_SCALE,
      h: (maxY - minY) * INNER_SCALE,
      cx: ORIGIN.x + ((minX + maxX) / 2) * INNER_SCALE,
      cy: ORIGIN.y + ((minY + maxY) / 2) * INNER_SCALE
    };
  })();

  /* Where the centre watermark hangs: the middle of Neptune's ring, the
     outermost concentric circle of the artwork. */
  var MARK_ANCHOR = (function () {
    var nep = BODIES[7];
    return {
      x: ORIGIN.x + (nep.ml + nep.orb / 2) * INNER_SCALE,
      y: ORIGIN.y + (nep.mt + nep.orb / 2) * INNER_SCALE
    };
  })();

  /* Sass stars(1000, 3300, 0, 0.9): 1000 dots over a 3300px square, drawn as
     2.8px circles with alpha random(1000)*.001. Reproduced on canvas, tiled on
     a 3300px lattice so the field is stable across resize and infinite in
     extent — tile (0,0) is the poster's own field. */
  var STAR_CELL = 3300;
  var STAR_PER_CELL = 1000;
  var STAR_RADIUS = 1.4;

  /* Sass stars(290, 290, -145, -104) on the asteroid belt. */
  var BELT = { count: 290, area: 290, min: -145, spread: -104 };

  var NAMES = BODIES.map(function (b) { return b.name; });
  var MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July',
                'August', 'September', 'October', 'November', 'December'];
  var TAU = Math.PI * 2;
  var J2000_MS = Date.UTC(2000, 0, 1, 12, 0, 0);
  var DAY_MS = 86400000;

  /* ---- helpers ---------------------------------------------------------- */

  function mulberry32(seed) {
    var a = seed >>> 0;
    return function () {
      a = (a + 0x6D2B79F5) | 0;
      var t = Math.imul(a ^ (a >>> 15), 1 | a);
      t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
      return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
    };
  }

  /* Sass random($n) returns an integer in 1..n */
  function sassRandom(rnd, n) { return 1 + Math.floor(rnd() * n); }

  function toDate(when) {
    if (when instanceof Date) return when;
    if (typeof when === 'number') return new Date(when);
    /* Match solaris-model's own parser: date-only strings are UTC noon, so the
       result never shifts with the visitor's timezone. */
    var s = String(when);
    return /^\d{4}-\d{2}-\d{2}$/.test(s) ? new Date(s + 'T12:00:00Z') : new Date(s);
  }

  function formatDate(when) {
    var d = toDate(when);
    return d.getUTCDate() + ' ' + MONTHS[d.getUTCMonth()] + ' ' + d.getUTCFullYear();
  }

  function deg(v) { return v.toFixed(2) + 'deg'; }

  /* ---- orbital angles (same numbers as design-generator/utils/ephemeris.js) */

  /* JPL's approximate Keplerian elements (valid 1800-2050), base value at
     J2000 and rate per Julian century: a, e, i, L, long. perihelion, node. */
  var ELEMENTS = {
    mercury: [[0.38709927, 0.20563593, 7.00497902, 252.25032350, 77.45779628, 48.33076593],
              [0.00000037, 0.00001906, -0.00594749, 149472.67411175, 0.16047689, -0.12534081]],
    venus:   [[0.72333566, 0.00677672, 3.39467605, 181.97909950, 131.60246718, 76.67984255],
              [0.00000390, -0.00004107, -0.00078890, 58517.81538729, 0.00268329, -0.27769418]],
    earth:   [[1.00000261, 0.01671123, -0.00001531, 100.46457166, 102.93768193, 0.0],
              [0.00000562, -0.00004392, -0.01294668, 35999.37244981, 0.32327364, 0.0]],
    mars:    [[1.52371034, 0.09339410, 1.84969142, -4.55343205, -23.94362959, 49.55953891],
              [0.00001847, 0.00007882, -0.00813131, 19140.30268499, 0.44441088, -0.29257343]],
    jupiter: [[5.20288700, 0.04838624, 1.30439695, 34.39644051, 14.72847983, 100.47390909],
              [-0.00011607, -0.00013253, -0.00183714, 3034.74612775, 0.21252668, 0.20469106]],
    saturn:  [[9.53667594, 0.05386179, 2.48599187, 49.95424423, 92.59887831, 113.66242448],
              [-0.00125060, -0.00050991, 0.00193609, 1222.49362201, -0.41897216, -0.28867794]],
    uranus:  [[19.18916464, 0.04725744, 0.77263783, 313.23810451, 170.95427630, 74.01692503],
              [-0.00196176, -0.00004397, -0.00242939, 428.48202785, 0.40805281, 0.04240589]],
    neptune: [[30.06992276, 0.00859048, 1.77004347, -55.12002969, 44.96476227, 131.78422574],
              [0.00026291, 0.00005105, 0.00035372, 218.45945325, -0.32241464, -0.00508664]],
    pluto:   [[39.48211675, 0.24882730, 17.14001206, 238.92903833, 224.06891629, 110.30393684],
              [-0.00031596, 0.00005170, 0.00004818, 145.20780515, -0.04062942, -0.01183482]]
  };
  var RAD = Math.PI / 180;
  function mod360(x) { return ((x % 360) + 360) % 360; }

  /* Heliocentric ecliptic longitude (degrees) at a Julian day. Kepler's
     equation is solved in RADIANS (the solaris-model bug was degrees). */
  function longitude(name, jd) {
    var el = ELEMENTS[name], b = el[0], c = el[1];
    var t = (jd - 2451545.0) / 36525.0;
    var e = b[1] + c[1] * t;
    var inc = (b[2] + c[2] * t) * RAD;
    var L = b[3] + c[3] * t, lp = b[4] + c[4] * t;
    var node = (b[5] + c[5] * t) * RAD;
    var w = lp * RAD - node;
    var M = mod360(L - lp) * RAD, E = M;
    for (var k = 0; k < 12; k++) {
      var step = (E - e * Math.sin(E) - M) / (1 - e * Math.cos(E));
      E -= step;
      if (Math.abs(step) < 1e-12) break;
    }
    var xo = Math.cos(E) - e, yo = Math.sqrt(Math.max(0, 1 - e * e)) * Math.sin(E);   /* a cancels in the angle */
    var cw = Math.cos(w), sw = Math.sin(w), co = Math.cos(node), so = Math.sin(node), ci = Math.cos(inc);
    var x = (cw * co - sw * so * ci) * xo + (-sw * co - cw * so * ci) * yo;
    var y = (cw * so + sw * co * ci) * xo + (-sw * so + cw * co * ci) * yo;
    return mod360(Math.atan2(y, x) / RAD);
  }

  function anglesFor(when) {
    /* toDate() reads a bare YYYY-MM-DD as 12:00 UTC, the time the prints use */
    var jd = toDate(when).getTime() / DAY_MS + 2440587.5;
    var out = {};
    for (var i = 0; i < NAMES.length; i++) out[NAMES[i]] = longitude(NAMES[i], jd);
    return out;
  }

  /* The rings are not centred on the Sun (the poster's design, kept), so
     turning a ring by the planet's angle about its own centre would bend the
     direction seen from the Sun by up to ~5 degrees. Turn it instead so its
     dot lands where the ray from the Sun at the true angle meets the ring.
     Geometry comes from BODIES and the .sun rule in pp-orrery.css (100px at
     margin -45px top, -5px left: centre (45, 5)); a dot sits on its ring's
     inner border edge (3.2px border), straight above the ring centre. */
  var SUN_C = { x: 45, y: 5 };
  var RING = {};
  BODIES.forEach(function (b) {
    RING[b.name] = { cx: b.ml + b.orb / 2 - SUN_C.x, cy: b.mt + b.orb / 2 - SUN_C.y, r: b.orb / 2 - 3.2 };
  });
  function ringAngle(name, a) {
    var g = RING[name];
    if (!g) return a;
    var u = a * RAD, ux = -Math.sin(u), uy = -Math.cos(u);
    var b = -(ux * g.cx + uy * g.cy), c = g.cx * g.cx + g.cy * g.cy - g.r * g.r;
    if (!(c < 0)) return a;                       /* Sun outside the ring: cannot happen on this poster */
    var s = -b + Math.sqrt(b * b - c);
    var hx = ux * s - g.cx, hy = uy * s - g.cy;
    var d = ((Math.atan2(-hx, -hy) / RAD - a) % 360 + 540) % 360 - 180;
    return a + d;                                 /* stays next to a, so glides unwrap as before */
  }

  /* Mean longitude of the Moon, same reference frame as the planet angles,
     so the little grey dot sits where the Moon actually was. */
  function moonLongitude(when) {
    var d = (toDate(when).getTime() - J2000_MS) / DAY_MS;
    return ((218.3164477 + 13.17639648 * d) % 360 + 360) % 360;
  }

  /* ---- DOM ------------------------------------------------------------- */

  function el(cls, tag) {
    var n = global.document.createElement(tag || 'div');
    if (cls) n.className = cls;
    return n;
  }

  function beltShadow(seed, rgb) {
    var rnd = mulberry32(seed ^ 0x9E3779B9);
    var out = [];
    for (var i = 0; i < BELT.count; i++) {
      var x = BELT.min + sassRandom(rnd, BELT.area);
      var y = BELT.min + sassRandom(rnd, BELT.area);
      var a = sassRandom(rnd, 1000) * 0.001;
      out.push(x + 'px ' + y + 'px 0 ' + BELT.spread + 'px rgba(' + rgb + ',' + a.toFixed(3) + ')');
    }
    return out.join(', ');
  }

  /* Every part is optional: blank text -> no tiled rows, blank mark/url ->
     no centre word/sub-line. The default treatment is now the single centre
     mark; the tiles (and their "not finished" vignette wash) only come back
     when a repeating text is explicitly configured. */
  function buildWatermark(cfg) {
    var wm = el('pp-wm');
    wm.setAttribute('aria-hidden', 'true');

    if (cfg.text) {
      var tile = el('pp-wm__tile');
      var unit = (cfg.text + ' · ').repeat(10);
      for (var i = 0; i < cfg.rows; i++) {
        var row = el('pp-wm__row');
        row.textContent = unit;
        tile.appendChild(row);
      }
      wm.appendChild(tile);
    }

    if (cfg.mark || cfg.url) {
      var mark = el('pp-wm__mark');
      if (cfg.mark) {
        var word = el('pp-wm__word', 'span');
        word.textContent = cfg.mark;
        mark.appendChild(word);
      }
      if (cfg.url) {
        var url = el('pp-wm__url', 'span');
        url.textContent = cfg.url;
        mark.appendChild(url);
      }
      wm.appendChild(mark);
    }

    if (cfg.text) wm.appendChild(el('pp-wm__vignette'));
    return wm;
  }

  /* z-index 1: over the star canvas, UNDER the stage — the Sun and planets
     draw on top of the mark, so it reads as etched into the sky. */
  var WM_CSS = 'position:absolute;top:0;right:0;bottom:0;left:0;z-index:1;' +
               'pointer-events:none;overflow:hidden;display:block;opacity:1;' +
               'visibility:visible;transform:none;filter:none;';

  /* ---- instance -------------------------------------------------------- */

  function create(host, options) {
    var opts = {
      theme: 'black',
      fit: 'poster',          /* 'poster' = the whole 4:5 sheet, 'system' = the orbits */
      zoom: 1,
      rules: true,            /* the print's two hairlines */
      date: '2021-08-10',
      moon: true,             /* place the Moon for the date */
      belt: true,             /* drift the asteroid belt with the date */
      starSeed: 1,
      starDensity: 1,
      starScale: 1,
      maxDpr: 2,
      /* Keep writing ever-increasing/decreasing angles instead of wrapping at
         360, so a CSS transition on the orbit takes the short way round. Only
         for interactive use — the frame renderer wants raw angles. */
      unwrap: false,
      animateMs: 0,           /* glide duration for setDate; rAF-driven */
      watermark: null,        /* null | { text, mark, url, alpha, scale, shift } */
      /* Fit the system into a sub-box of the host instead of the whole host:
         fractions {x, y, w, h} of the host size. The star field still covers
         the full host — this only places the orbits (and the watermark, which
         anchors to the Sun). null = the whole host. */
      viewBox: null,
      autoResize: true
    };
    for (var k in (options || {})) if (options[k] !== undefined) opts[k] = options[k];

    host.classList.add('pp-orrery');
    host.innerHTML = '';
    host.setAttribute('data-pp-theme', opts.theme);
    host.setAttribute('data-pp-rules', opts.rules ? 'on' : 'off');

    var sky = el('pp-sky');
    var stars = el('pp-stars', 'canvas');
    var stage = el('pp-stage');
    var ruleTop = el('pp-rule pp-rule--top');
    var ruleBottom = el('pp-rule pp-rule--bottom');
    var syst = el('solar-syst');
    var inner = el('solar-syst-inner');

    /* DOM order matters: everything shares z-index 999, so the belt has to
       come last to sit over the orbit rings, exactly as in index.html. */
    var nodes = {};
    inner.appendChild(el('sun'));
    for (var i = 0; i < NAMES.length; i++) {
      nodes[NAMES[i]] = el(NAMES[i]);
      inner.appendChild(nodes[NAMES[i]]);
    }
    var belt = el('asteroids-belt');
    inner.appendChild(belt);

    syst.appendChild(inner);
    stage.appendChild(ruleTop);
    stage.appendChild(ruleBottom);
    stage.appendChild(syst);

    host.appendChild(sky);
    host.appendChild(stars);
    host.appendChild(stage);

    var wm = null;
    var wmCfg = null;
    if (opts.watermark) {
      /* An explicit empty string switches a part off; only an absent field
         falls back. A watermark with every part blank is no watermark. */
      var w = opts.watermark;
      wmCfg = {
        text: w.text == null ? '' : String(w.text),
        mark: w.mark == null ? 'PlanetryPrints.com' : String(w.mark),
        url: w.url == null ? '' : String(w.url),
        alpha: w.alpha == null ? 0.1 : w.alpha,
        scale: w.scale == null ? 1 : w.scale,      /* centre-mark size, ×ideal */
        shift: w.shift == null ? 0 : w.shift,      /* centre-mark Y offset, % of height */
        rows: 0
      };
      if (!wmCfg.text && !wmCfg.mark && !wmCfg.url) wmCfg = null;
    }

    var view = { k: 1, tx: 0, ty: 0 };
    var size = { w: 0, h: 0 };
    var ctx = stars.getContext('2d');
    var destroyed = false;
    var lastLayout = null;

    function starRGB() { return opts.theme === 'white' ? '0,0,0' : '255,255,255'; }

    function computeView(w, h) {
      var bx = 0, by = 0, bw = w, bh = h;
      var vb = opts.viewBox;
      if (vb) {
        bx = vb.x * w;
        by = vb.y * h;
        bw = Math.max(1, vb.w * w);
        bh = Math.max(1, vb.h * h);
      }
      var k, cx, cy;
      if (opts.fit === 'system') {
        k = Math.min(bw / BBOX.w, bh / BBOX.h) * opts.zoom;
        cx = BBOX.cx; cy = BBOX.cy;
      } else {
        k = Math.min(bw / STAGE.w, bh / STAGE.h) * opts.zoom;
        cx = STAGE.w / 2; cy = STAGE.h / 2;
      }
      return { k: k, tx: bx + bw / 2 - cx * k, ty: by + bh / 2 - cy * k };
    }

    function drawStars() {
      var w = size.w, h = size.h;
      if (!w || !h) return;
      var dpr = Math.max(1, Math.min(opts.maxDpr, global.devicePixelRatio || 1));
      stars.width = Math.round(w * dpr);
      stars.height = Math.round(h * dpr);
      stars.style.width = w + 'px';
      stars.style.height = h + 'px';
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      ctx.clearRect(0, 0, w, h);
      ctx.fillStyle = 'rgb(' + starRGB() + ')';

      var k = view.k, tx = view.tx, ty = view.ty;
      var r = Math.max(0.55 / dpr, STAR_RADIUS * k * opts.starScale);
      var per = Math.max(0, Math.round(STAR_PER_CELL * opts.starDensity));
      var cx0 = Math.floor((-tx / k) / STAR_CELL);
      var cx1 = Math.floor(((w - tx) / k) / STAR_CELL);
      var cy0 = Math.floor((-ty / k) / STAR_CELL);
      var cy1 = Math.floor(((h - ty) / k) / STAR_CELL);

      for (var cy = cy0; cy <= cy1; cy++) {
        for (var cx = cx0; cx <= cx1; cx++) {
          var rnd = mulberry32(((opts.starSeed | 0) ^ Math.imul(cx, 73856093) ^ Math.imul(cy, 19349663)) >>> 0);
          for (var i = 0; i < per; i++) {
            var sx = cx * STAR_CELL + sassRandom(rnd, STAR_CELL);
            var sy = cy * STAR_CELL + sassRandom(rnd, STAR_CELL);
            var a = sassRandom(rnd, 1000) * 0.001;
            /* the shadow box of a 1px element at top:-2px, offset (sx, sy) */
            var px = (sx + 0.5) * k + tx;
            var py = (sy - 1.5) * k + ty;
            if (px < -4 || py < -4 || px > w + 4 || py > h + 4) continue;
            ctx.globalAlpha = a;
            ctx.beginPath();
            ctx.arc(px, py, r, 0, TAU);
            ctx.fill();
          }
        }
      }
      ctx.globalAlpha = 1;
    }

    function sizeWatermark() {
      if (!wm) return;
      var u = Math.min(size.w, size.h) || 600;
      var gap = Math.round(u * 0.115);
      host.style.setProperty('--pp-wm-alpha', String(wmCfg.alpha));
      host.style.setProperty('--pp-wm-size', Math.round(u * 0.030) + 'px');
      host.style.setProperty('--pp-wm-gap', gap + 'px');
      /* The centre mark spans the rendered SYSTEM, not the layout box: it
         sits behind the orbits, edge to edge, wherever they are and however
         big they are. One letterspaced uppercase glyph ~1.05em wide. */
      var bw = BBOX.w * view.k * (wmCfg.scale || 1);
      var chars = (wmCfg.mark || '').length;
      var fits = chars ? bw / (chars * 1.05) : u * 0.085;
      host.style.setProperty('--pp-wm-mark-size', Math.max(10, Math.round(fits)) + 'px');
      host.style.setProperty('--pp-wm-shift', Math.round(((wmCfg.shift || 0) / 100) * size.h) + 'px');
      host.style.setProperty('--pp-wm-url-size', Math.max(9, Math.round(u * 0.026)) + 'px');
      /* enough rows to fill the 220%-tall rotated tile (none without text) */
      var want = wmCfg.text
        ? Math.max(4, Math.ceil((Math.max(size.w, size.h) * 2.2) / (gap + u * 0.05)) + 2)
        : 0;
      if (want !== wmCfg.rows) {
        wmCfg.rows = want;
        var fresh = buildWatermark(wmCfg);
        host.replaceChild(fresh, wm);
        wm = fresh;
        wm.style.cssText = WM_CSS;
      }
    }

    function layout() {
      var w = host.clientWidth, h = host.clientHeight;
      if (!w || !h) return;
      var nextView = computeView(w, h);
      /* Several observers can report the same settled slot. Resetting a
         canvas discards its bitmap, even when its dimensions are unchanged;
         avoid that redraw and the stage/watermark writes for identical fits.
         Include raster inputs because options are public and callers may
         change star settings or display DPR before calling refit(). */
      var inputs = [w, h, nextView.k, nextView.tx, nextView.ty,
        global.devicePixelRatio || 1, opts.maxDpr, opts.starScale,
        opts.starDensity, opts.starSeed, opts.theme];
      var same = lastLayout && inputs.length === lastLayout.length;
      for (var i = 0; same && i < inputs.length; i++) {
        if (inputs[i] !== lastLayout[i]) same = false;
      }
      if (same) return;
      size.w = w; size.h = h;
      view = nextView;
      stage.style.transform = 'translate(' + view.tx + 'px, ' + view.ty + 'px) scale(' + view.k + ')';
      /* The centre mark anchors to the centre of Neptune's ring — the
         outermost concentric circle, the one the eye judges centring
         against. (Not the Sun, which sits off the rings' centre; not the
         bounding box, which Pluto's eccentric ring drags upward.) */
      host.style.setProperty('--pp-wm-cx', Math.round(MARK_ANCHOR.x * view.k + view.tx) + 'px');
      host.style.setProperty('--pp-wm-cy', Math.round(MARK_ANCHOR.y * view.k + view.ty) + 'px');
      drawStars();
      sizeWatermark();
      lastLayout = inputs;
    }

    function paintBelt() {
      host.style.setProperty('--pp-belt-shadow', beltShadow(opts.starSeed | 0, starRGB()));
    }

    var current = null;
    var shown = {};   /* last angle written per body, for unwrapping */
    var moonShown = null;
    var beltShown = null;
    var raf = null;
    var transitionVersion = 0;
    var writtenAngles = {}, writtenBelt = null, writtenMoon = null;

    function writeAngles(vals, beltDeg) {
      for (var i = 0; i < NAMES.length; i++) {
        var n = NAMES[i];
        /* negate the number, not the string: an unwrapped angle can be
           negative, and 'rotateZ(--62deg)' is invalid CSS the browser drops */
        var transform = 'rotateZ(' + (-vals[n]).toFixed(3) + 'deg)';
        if (writtenAngles[n] !== transform) {
          nodes[n].style.transform = transform;
          writtenAngles[n] = transform;
        }
      }
      if (opts.belt && beltDeg != null) {
        var beltTransform = 'rotateZ(' + beltDeg.toFixed(3) + 'deg)';
        if (writtenBelt !== beltTransform) {
          belt.style.transform = beltTransform;
          writtenBelt = beltTransform;
        }
      }
    }

    function writeMoon(value) {
      if (!opts.moon || value == null) return;
      moonShown = value;
      var moon = deg(value);
      if (writtenMoon === moon) return;
      /* Only Earth's pseudo-element consumes this angle. A host-level write
         invalidates the whole artwork and wakes the watermark guard, whose
         computed-style check would then flush styles on every glide frame.
         Keep the same CSS variable local to its actual consumer instead. */
      nodes.earth.style.setProperty('--pp-moon', moon);
      writtenMoon = moon;
    }

    function prepareTransition(when, glideMoon) {
      if (raf != null) { global.cancelAnimationFrame(raf); raf = null; }
      var version = ++transitionVersion;
      var previous = current;
      current = toDate(when);
      /* opts.direction: planets travel the way time runs, forward along
         their orbits for a later date and backward for an earlier one. */
      var timeSign = (opts.direction && previous) ? (current.getTime() >= previous.getTime() ? 1 : -1) : 0;
      var ang = anglesFor(current);
      var from = {}, to = {};
      var started = shown[NAMES[0]] != null;
      for (var i = 0; i < NAMES.length; i++) {
        var n = NAMES[i];
        var a = ringAngle(n, ang[n]);   /* ring turn that puts the dot on the true direction */
        if (timeSign && shown[n] != null) {
          var dd = ((a - shown[n]) % 360 + 360) % 360;        /* 0..360 forward */
          if (timeSign < 0 && dd > 0) dd -= 360;               /* -360..0 backward */
          a = shown[n] + dd;
        } else if (opts.unwrap && shown[n] != null) {
          var d = ((a - shown[n]) % 360 + 540) % 360 - 180;   /* -180..180 */
          a = shown[n] + d;
        }
        from[n] = (shown[n] == null) ? a : shown[n];
        to[n] = a;
      }
      /* The Moon rides inside .earth, which is already rotated by -(Earth's ring turn),
         so add that back to land the dot on the Moon's real longitude. */
      var moonTo = null, moonFrom = moonShown;
      if (opts.moon) {
        moonTo = ringAngle('earth', ang.earth) - moonLongitude(current);
        if (glideMoon && opts.unwrap && moonShown != null) {
          moonTo = moonShown + ((moonTo - moonShown) % 360 + 540) % 360 - 180;
        }
        if (moonFrom == null) moonFrom = moonTo;
        /* setDate historically updates the Moon immediately. Controlled
           reveals opt into a seekable Moon without changing those callers. */
        if (!glideMoon) writeMoon(moonTo);
      }
      /* No physical meaning — just the poster's own 2191-day belt drift, so a
         long animation shows the belt turning instead of sitting frozen. */
      var beltTo = null;
      if (opts.belt) {
        var days = (current.getTime() - J2000_MS) / DAY_MS;
        beltTo = -360 * (days / 2191);
      }
      var beltFrom = (beltShown == null) ? beltTo : beltShown;
      var lastProgress = null;

      function seek(progress) {
        if (destroyed || version !== transitionVersion) return;
        var t = Math.max(0, Math.min(1, Number(progress) || 0));
        /* A reveal holds the start/end pose for several seconds. Those
           frames must not rewrite the whole renderer or wake observers.
           Each new transition still evaluates its first seek, even at 0. */
        if (t === lastProgress) return;
        lastProgress = t;
        var e = opts.ease ? opts.ease(t) : 1 - Math.pow(1 - t, 3);   /* ease-out by default */
        var cur = {};
        for (var k = 0; k < NAMES.length; k++) {
          var nn = NAMES[k];
          cur[nn] = from[nn] + (to[nn] - from[nn]) * e;
          shown[nn] = cur[nn];
        }
        beltShown = (beltTo == null) ? null : beltFrom + (beltTo - beltFrom) * e;
        writeAngles(cur, beltShown);
        if (glideMoon && moonTo != null) writeMoon(moonFrom + (moonTo - moonFrom) * e);
      }

      return { seek: seek, angles: ang, started: started };
    }

    /* An external animation clock can share the usual date-glide path. No
       frame is scheduled here; seek(0) restores the captured starting pose,
       and seek(1) settles the selected date. A newer transition invalidates
       older handles so a late reveal callback cannot overwrite a new date. */
    function prepareDateTransition(when) {
      var transition = prepareTransition(when, true);
      return { seek: transition.seek };
    }

    /* The glide between dates is driven by rAF, NOT by CSS transitions: a
       declared `transition: transform` on these poster-sized divs makes newer
       iOS WebKit allocate a GPU layer per planet at full layout size —
       hundreds of MB before anything animates — and the GPU process is
       killed on load. Repainting small dots for ~55 frames is far cheaper
       than one promoted layer. */
    function setDate(when) {
      var transition = prepareTransition(when, false);
      var ms = opts.animateMs;
      if (!transition.started || !ms || !global.requestAnimationFrame) {
        transition.seek(1);
        return transition.angles;
      }
      var t0 = null;
      var step = function (now) {
        if (t0 == null) t0 = now;
        var t = Math.min(1, (now - t0) / ms);
        transition.seek(t);
        raf = (t < 1) ? global.requestAnimationFrame(step) : null;
      };
      raf = global.requestAnimationFrame(step);
      return transition.angles;
    }

    /* ---- watermark integrity ------------------------------------------- */

    var observer = null, ticker = null, strikes = 0;
    var watermarkFrame = null, watermarkTask = null, watermarkVersion = 0;
    var watermarkStopped = false;

    function cancelWatermarkCheck() {
      watermarkVersion++;
      if (watermarkFrame !== null) global.cancelAnimationFrame(watermarkFrame);
      if (watermarkTask !== null) global.clearTimeout(watermarkTask);
      watermarkFrame = null;
      watermarkTask = null;
    }

    function scheduleWatermarkCheck() {
      if (!wmCfg || destroyed || watermarkStopped) return;
      if (global.document.hidden || !global.requestAnimationFrame) {
        cancelWatermarkCheck();
        enforceWatermark();
        return;
      }
      if (watermarkFrame !== null || watermarkTask !== null) return;
      var version = ++watermarkVersion;
      /* Keep the periodic computed-style read out of the animation's write
         phase. The task queued from rAF runs after that rendering opportunity.
         MutationObserver repairs remain immediate; only the heartbeat waits. */
      watermarkFrame = global.requestAnimationFrame(function () {
        if (version !== watermarkVersion || destroyed || watermarkStopped) return;
        watermarkFrame = null;
        watermarkTask = global.setTimeout(function () {
          if (version !== watermarkVersion || destroyed || watermarkStopped) return;
          watermarkTask = null;
          enforceWatermark();
        }, 0);
      });
    }

    function watermarkBroken() {
      if (!wmCfg) return false;
      if (!wm || wm.parentNode !== host) return true;
      if (!wm.firstChild) return true;
      var cs = global.getComputedStyle(wm);
      if (cs.display === 'none' || cs.visibility === 'hidden') return true;
      if (parseFloat(cs.opacity) < 0.9) return true;
      return false;
    }

    /* Last resort. Only reachable when something keeps the watermark suppressed
       through repeated repairs — at which point showing clean art would be
       worse than showing none, and looping forever would be worse than both. */
    function surrender() {
      watermarkStopped = true;
      cancelWatermarkCheck();
      if (observer) { observer.disconnect(); observer = null; }
      if (ticker !== null) { global.clearInterval(ticker); ticker = null; }
      stage.style.opacity = '0.3';
    }

    function enforceWatermark() {
      if (!wmCfg || destroyed || watermarkStopped) return;
      if (!watermarkBroken()) { strikes = 0; return; }
      if (++strikes > 6) { surrender(); return; }

      /* A gutted or detached node cannot be styled back to life — rebuild it.
         (Missing this was an infinite loop: broken forever, repaired never.) */
      if (!wm || wm.parentNode !== host || !wm.firstChild) {
        if (wm && wm.parentNode === host) host.removeChild(wm);
        wmCfg.rows = 0;
        wm = buildWatermark(wmCfg);
        host.appendChild(wm);
        wm.style.cssText = WM_CSS;
        sizeWatermark();
      } else {
        wm.style.cssText = WM_CSS;
        if (host.lastElementChild !== wm) host.appendChild(wm);
      }

      /* Drop the records our own repair just generated, so the observer does
         not immediately re-enter on mutations we made on purpose. */
      if (observer) observer.takeRecords();
    }

    /* ---- boot ---------------------------------------------------------- */

    if (wmCfg) {
      wmCfg.rows = wmCfg.text ? 6 : 0;
      wm = buildWatermark(wmCfg);
      host.appendChild(wm);
      wm.style.cssText = WM_CSS;

      host.addEventListener('contextmenu', function (e) { e.preventDefault(); });
      host.addEventListener('dragstart', function (e) { e.preventDefault(); });

      if (global.MutationObserver) {
        /* The glide writes planet transforms inside the stage every frame;
           those are the engine's own mutations, not tampering. Skipping them
           matters: enforceWatermark calls getComputedStyle, and a forced
           style recalc per animation frame against a full theme stylesheet
           (Dawn's) makes the whole page crawl. */
        observer = new global.MutationObserver(function (records) {
          for (var i = 0; i < records.length; i++) {
            var t = records[i].target;
            if (!(t && t !== stage && stage.contains(t))) { enforceWatermark(); return; }
          }
        });
        observer.observe(host, { childList: true, subtree: true, attributes: true,
                                 attributeFilter: ['style', 'class', 'hidden'] });
      }
      ticker = global.setInterval(scheduleWatermarkCheck, 900);
    }

    paintBelt();
    layout();
    setDate(opts.date);

    var ro = null;
    if (opts.autoResize) {
      if (global.ResizeObserver) {
        ro = new global.ResizeObserver(function () { layout(); });
        ro.observe(host);
      } else {
        global.addEventListener('resize', layout);
      }
    }

    return {
      host: host,
      stage: stage,
      setDate: setDate,
      prepareDateTransition: prepareDateTransition,
      getDate: function () { return current; },
      getAngles: function () { return anglesFor(current); },
      setTheme: function (t) {
        opts.theme = (t === 'white') ? 'white' : 'black';
        host.setAttribute('data-pp-theme', opts.theme);
        paintBelt();
        drawStars();
      },
      setFit: function (f) { opts.fit = f; layout(); },
      setZoom: function (z) { opts.zoom = z; layout(); },
      setViewBox: function (vb) { opts.viewBox = vb || null; layout(); },
      setRules: function (on) {
        opts.rules = !!on;
        host.setAttribute('data-pp-rules', on ? 'on' : 'off');
      },
      setStarSeed: function (s) { opts.starSeed = s | 0; paintBelt(); drawStars(); },
      refit: layout,
      options: opts,
      destroy: function () {
        destroyed = true;
        cancelWatermarkCheck();
        if (raf != null) global.cancelAnimationFrame(raf);
        if (observer) observer.disconnect();
        if (ticker !== null) global.clearInterval(ticker);
        if (ro) ro.disconnect();
        else global.removeEventListener('resize', layout);
        host.innerHTML = '';
      }
    };
  }

  global.PPOrrery = {
    STAGE: STAGE,
    BODIES: BODIES,
    BBOX: BBOX,
    NAMES: NAMES,
    ORIGIN: ORIGIN,
    INNER_SCALE: INNER_SCALE,
    anglesFor: anglesFor,
    ringAngle: ringAngle,
    formatDate: formatDate,
    create: create
  };
})(typeof window !== 'undefined' ? window : this);
